/**
 * Campaign History Types
 *
 * Events that chronicle what happens in a campaign: encounters,
 * kills, scene transitions, XP awards.
 */
import { z } from 'zod';
// =============================================================================
// EVENT DATA SCHEMAS
// =============================================================================
export const EncounterStartDataSchema = z.object({
    type: z.literal('encounter_start'),
    encounterId: z.string(),
    sceneName: z.string().optional(),
    participantNames: z.array(z.string()),
});
export const EncounterEndDataSchema = z.object({
    type: z.literal('encounter_end'),
    encounterId: z.string(),
    rounds: z.number(),
    durationMs: z.number().optional(),
    survivors: z.array(z.string()),
    kills: z.array(z.string()),
    totalXp: z.number().optional(),
});
export const MobKilledDataSchema = z.object({
    type: z.literal('mob_killed'),
    mobId: z.string(),
    mobName: z.string(),
    killerId: z.string().optional(),
    killerName: z.string().optional(),
    xpValue: z.number().optional(),
    cr: z.string().optional(),
});
export const SceneTransitionDataSchema = z.object({
    type: z.literal('scene_transition'),
    fromScene: z.string().optional(),
    toScene: z.string(),
    activeMobsCarried: z.number().optional(),
    deadMobsArchived: z.number().optional(),
});
export const XpAwardedDataSchema = z.object({
    type: z.literal('xp_awarded'),
    characterId: z.string(),
    characterName: z.string(),
    amount: z.number(),
    source: z.string(),
});
//# sourceMappingURL=history-types.js.map